import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { useLang } from "@/lib/i18n";
import api from "@/lib/api";
import { toast } from "sonner";

export const PendingFollowHandler = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const { t } = useLang();
  const running = useRef(false);

  useEffect(() => {
    if (!user || running.current) return;
    const raw = sessionStorage.getItem("pending_follow");
    if (!raw) return;
    running.current = true;
    sessionStorage.removeItem("pending_follow");
    const { slug, mosqueId } = JSON.parse(raw);
    (async () => {
      try {
        let already = false;
        try {
          const { data: mem } = await api.get(`/associations/${slug}/membership`);
          already = mem.followed_mosques?.includes(mosqueId);
        } catch {}
        if (!already) {
          const { data } = await api.post(`/associations/${slug}/mosques/${mosqueId}/follow`);
          if (data.following) toast.success(t("following_success"));
        }
      } catch {}
      navigate(`/${slug}/mosques/${mosqueId}`);
      running.current = false;
    })();
  }, [user, navigate, t]);

  return null;
};
